import { Box, CircularProgress } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { fetchUser } from "../../../services/users";
import { Edit } from "./-internal-components/Edit";
import { EditEquinor } from "./-internal-components/EditEquinor";

const RouteComponent: FC = () => {
  const user = useAuth().user;

  const { data: userData, isLoading } = useQuery({
    enabled: !!user?.id,
    queryFn: () => fetchUser(Number(user?.id)),
    queryKey: ["userId", user?.id, user?.photo_url],
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading || !userData) {
    return (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return user?.equinor ? (
    <EditEquinor userData={userData} />
  ) : (
    <Edit userData={userData} />
  );
};

export const Route = createFileRoute("/_private/users/edit")({
  component: RouteComponent,
});
